import { useEffect } from 'react';
import { Navbar } from '../../components';
import CompanyHero from '@/components/sections/CompanyHero';
import CompanyMission from '@/components/sections/CompanyMission';
import CompanyAwards from '@/components/sections/CompanyAwards';
import CompanyTeam from '@/components/sections/CompanyTeam';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Footer from "@/components/sections/Footer";
import SEO from '@/components/SEO';

interface AboutProps {
}

export async function getStaticProps({ locale }:any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'about',
      ])),
      // Will be passed to the page component as props
    },
  }
}

export default function About({ }: AboutProps) {
  const { t } = useTranslation('about');
  const router = useRouter();
  const { asPath: pathname } = router;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Track mouse position for light effects
  useEffect(() => {
    const updateCursor = ({ x, y }: { x: number; y: number }) => {
      document.documentElement.style.setProperty("--x", x.toString());
      document.documentElement.style.setProperty("--y", y.toString());
    };

    document.body.addEventListener("pointermove", updateCursor);
    return () => document.body.removeEventListener("pointermove", updateCursor);
  }, []);

  return (
    <div className="min-h-screen w-full overflow-hidden" >
      <SEO
        title={t('meta.title')}
        description={t('meta.description')}
        ogImage="/images/og-about.png"
      />

      <Navbar />
      <CompanyHero />
      <CompanyAwards />
      <CompanyMission />
      <CompanyTeam />
      <Footer />
    </div>
  );
}
